<vitamui-slide-toggle [(ngModel)]="checked" (ngModelChange)="_checkedChange.next($event)" [disabled]="disabled || forceDisabled">
  <ng-content></ng-content>
</vitamui-slide-toggle>
